import useLanguage from '@/utils/hooks/useLanguage';
import { LuLayout } from 'react-icons/lu';
import AddModule, { AddModuleProps } from './AddModule';
import StartWithATemplate from './StartWithATemplate';

const EmptyWorkspace = (props: AddModuleProps) => {
    const lang = useLanguage();

    return (
        <div className="h-full bg-brand-background">
            <div className="absolute inset-0 flex flex-col items-center justify-center text-brand-neutral-500">
                <LuLayout className="w-16 h-16 mb-4 opacity-20" />
                <p className="text-lg font-medium">{lang.workspace.emptyWorkspace}</p>
                <p className="text-sm mb-6">{lang.workspace.addModulesToYourWorkspace}</p>
                <div className="flex gap-2 items-center">
                    <AddModule {...props} hasBg />
                    <StartWithATemplate {...props} />
                </div>
            </div>
        </div>
    );
};

export default EmptyWorkspace;
